module.exports = __webpack_public_path__ + "img/logo.1191e6e2.svg";